import { useEffect, useRef } from 'react';
import React from 'react';
import { toast } from 'sonner';
import { CheckCircle2Icon } from 'lucide-react';
import { IMG_PACK_PRINCIPAL } from '../utils/constants';
interface Comprador {
  nombre: string;
  ciudad: string;
}

// Cargá acá los nombres y ciudades que quieras mostrar.
const COMPRADORES: Comprador[] = [{
  nombre: 'Carolina F.',
  ciudad: 'Posadas, Misiones'
}, {
  nombre: 'Mariano S.',
  ciudad: 'Rosario, Santa Fe'
}, {
  nombre: 'Verónica A.',
  ciudad: 'Córdoba'
}, {
  nombre: 'Débora Q.',
  ciudad: 'Neuquén'
}, {
  nombre: 'Gustavo M.',
  ciudad: 'Salta'
}, {
  nombre: 'Lucía B.',
  ciudad: 'La Plata, Buenos Aires'
}, {
  nombre: 'Natalia R.',
  ciudad: 'Oberá, Misiones'
}, {
  nombre: 'Pablo G.',
  ciudad: 'Mar del Plata, Buenos Aires'
}, {
  nombre: 'Sofía L.',
  ciudad: 'San Miguel de Tucumán'
}, {
  nombre: 'Andrés V.',
  ciudad: 'Mendoza'
}];
const PRIMER_AVISO_MS = 10_000;
const MIN_INTERVALO_MS = 15_000;
const MAX_INTERVALO_MS = 30_000;
const DURACION_MS = 4_000;
function siguienteIntervalo(): number {
  return MIN_INTERVALO_MS + Math.random() * (MAX_INTERVALO_MS - MIN_INTERVALO_MS);
}
export function PurchasePopup() {
  const indexRef = useRef(0);
  useEffect(() => {
    if (COMPRADORES.length === 0) return;
    let timeoutId = window.setTimeout(function mostrar() {
      const comprador = COMPRADORES[indexRef.current % COMPRADORES.length];
      indexRef.current += 1;
      toast.custom(() => <div className="flex items-center gap-3 w-[300px] max-w-[calc(100vw-2rem)] rounded-2xl bg-white border border-crema-alt shadow-xl px-3 py-3" data-id="element-38" data-mp="n7d9ykbj18e7">
            <img src={IMG_PACK_PRINCIPAL} alt="" aria-hidden="true" loading="lazy" className="w-12 h-12 object-contain shrink-0" data-id="element-39" data-mp="x5kqx35tfqg7" />
            <div className="min-w-0" data-id="element-40" data-mp="28jeu4jjjb3ei">
              <p className="text-sm font-bold text-violeta truncate" data-id="element-41" data-mp="28mkgvs4oxt72">
                {comprador.nombre}{' '}
                <span className="font-normal text-tinta/60" data-id="element-42" data-mp="23npru8g4r8ei">· {comprador.ciudad}</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1.5 text-xs text-tinta/70" data-id="element-43" data-mp="2fnnz540zgzwz">
                <CheckCircle2Icon className="w-3.5 h-3.5 text-coral shrink-0" aria-hidden="true" data-id="element-44" data-mp="2fph9ouepw4a9" />
                acaba de comprar este producto
              </p>
            </div>
          </div>, {
        duration: DURACION_MS,
        position: 'bottom-left'
      });
      timeoutId = window.setTimeout(mostrar, siguienteIntervalo());
    }, PRIMER_AVISO_MS);
    return () => window.clearTimeout(timeoutId);
  }, []);
  return null;
}